import React, { Component } from "react";
//scss
import "./Plans.scss";

//material UI
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";

//reources
import PlansInfoUSA from "../Plans/PlansInfoUSA.jpg";
import PlansInfoIND from "../Plans/PlansInfoIND.jpg";
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PlansAction from "./PlansAction";
import {
  APIResponse,
  HttpStatus,
  OperationStatus,
  SUBSCRIPTION_INTERVAL,
  SUBSCRIPTION_PLAN_NAME,
} from "../../Communication/Constants";
import { PATHS } from "../../Constants";
import { Strings } from "../../Resources/Strings/i18n";
import { Alert } from "react-bootstrap";

import Spinner from "../Spinner/Spinner";
import moment from "moment";
import { AccessModal } from "../AccessModal/AccessModal";
import CryptoJS from "crypto-js";
import CommonUtils from "../../Utils/CommonUtils";

class Plans extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      mobile: "",
      selectedPlan: "STANDARD",
      currentPlan: "FREE",
      freeProductPlan: "",
      plusProductPlan: "",
      premiumProductPlan: "",
      errorMessage: "",
      errorCase: false,
      showSpinner: false,
      showAccessModal: false,
    };

    this.PlansAction = new PlansAction();
    this.handleShowAccessModal = this.handleShowAccessModal.bind(this);
    this.handleCloseAccessModal = this.handleCloseAccessModal.bind(this);
  }

  componentDidMount = () => {
    this.reset();
    this.getTransactionHistory();
    this.getProductPlanInfo();
    let userId = this.props.userAccessTokenInfo.userId;
    this.getUserMappingList(userId);
  };

  reset = () => {
    this.props.cleanCreateTransactionData();
  };

  componentDidUpdate() {
        // console.log('componentdidUpdate Plans- state', this.state);
        // console.log('componentdidUpdate Plans- props ', this.props);
  }

  showModal = () => {
    this.setState({ show: true });
  };

  renderAlert = () => {
    return (
      <Alert variant="danger" className="alertMessage">
        {this.state.errorMessage}
      </Alert>
    );
  };

  

  createTransaction = (
    device_type,
    paid_for_user_id,
    self_upgrade,
    connection_upgrades_array,
    country_code
  ) => {
    this.setState({showSpinner: true});
    let requestBody = {
      device_type: device_type,
      upgrades_list: [
        {
          paid_for: paid_for_user_id,
          connection_upgrades: connection_upgrades_array,
          self_upgrade: {
            status: self_upgrade.status,
            product_id: self_upgrade.product_id,
          }
        },
      ],
      country_code: country_code,
    };
    this.PlansAction.createTransactionV2(requestBody, (actionCallback) => {
      if (actionCallback.status === OperationStatus.SUCCESS) {
        // console.log("Success: Create Transaction V2 -", actionCallback.data.data);
        this.setState({ createtransactionResponse: actionCallback.data.data, showSpinner: false });
        this.props.history.push(PATHS.PLANS + PATHS.CHECKOUT);
      } else {
        this.setState({
          errorCase: true,
          showSpinner: false,
          errorMessage: actionCallback.error.errorMessage,
        });
        // console.log("Error: Create Transaction V2 -", actionCallback.error);
      }
    });
  };

  getTransactionHistory = () => {
    this.setState({showSpinner: true});
    this.PlansAction.getTransactionHistory((actionCallback) => {
      if (actionCallback.status === OperationStatus.SUCCESS) {
        if (actionCallback.data.data.transactions.length !== 0) {
          actionCallback.data.data.transactions.forEach((transaction) => {
            if (transaction.subscription_object && 
                transaction.subscription_object.subscription_type === 'STRIPE' && 
                transaction.subscription_object.subscription_status === "SUCCESS") {
                this.setState({
                    activeTransactionExists: true,
                    activeTransaction: transaction,
                    showSpinner: false
                });
            }
            else {
              this.setState({showSpinner: false})
            }
          });
        }
        else {
          this.setState({transactionsExists: false, showSpinner: false});
        } 
      }
      else 
        {
          if (
            actionCallback.error.errorCode === HttpStatus.UNAUTHORIZED ||
            actionCallback.error.errorCode === APIResponse.INVALID_AUTH_GRANT
          ) {
            this.setState({
              errorCase: true,
              errorMessage: Strings("ERROR_INVALID_AUTH_GRANT"),
              showSpinner: false,
            });
          } else {
            this.setState({
              errorCase: true,
              errorMessage: actionCallback.error.errorMessage,
              showSpinner: false,
            });
          }
        }
    });
  };

  getUserMappingList = (userId) => {
    this.PlansAction.getUserMappingList({ userId }, (actionCallback) => {
      if (actionCallback.status === OperationStatus.SUCCESS) {
          if (actionCallback.data.data.monitoring_users && actionCallback.data.data.monitoring_users.length !== 0) {
            actionCallback.data.data.monitoring_users.forEach((user) => {
              if (user.subscription.product.display_name === "FREE") {
                this.setState({ freePlanCaregiversExists: true });
              } else {
                this.setState({ freePlanCaregiversExists: false });
              }
            });
          }
          else {
            this.setState({ errorCase: true, errorMessage: 'Please Add Caregivers and try again!' });
          }
      } else {
        this.setState({
          errorCase: true,
          errorMessage: actionCallback.error.errorMessage,
          showSpinner: false
        });
      }
    });
  };

  getProductPlanInfo() {
    this.PlansAction.getProductPlanInfo((actionCallback) => {
      if (actionCallback.status === OperationStatus.SUCCESS) {
        this.setState({ products: actionCallback.data.data.products });
      } else {
        this.setState({
          errorCase: true,
          errorMessage: actionCallback.error.errorMessage,
          showSpinner: false,
        });
      }
    });
  }

  renderPlanComparisonTable(countryCode) {
    let currencySymbol = '$';
    let monthlyStandardAmount = 1.99;
    let monthlyPremiumAmount = 4.99;
    if (countryCode === "IND") {
      currencySymbol = '₹';
      monthlyStandardAmount = 99;
      monthlyPremiumAmount = 299;
    }
    return (
      <>
        <div className="comparePlanLabel">Subscription Plans</div>
        <div className="planComparisonTable">
          <table>
            <thead>
              <tr>
                <th>Features</th>
                <th>{"Standard"}</th>
                <th>{"Premium"}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Watch</td>
                <td>Yes</td>
                <td>Yes</td>
              </tr>
              <tr>
                <td>Health & Wellness Data</td>
                <td>Yes</td>
                <td>Yes</td>
              </tr>
              <tr>
                <td># of Days</td>
                <td>1 Month</td>
                <td>3 Months</td>
              </tr>
              <tr>
                <td>Email & Download Reports</td>
                <td>Yes</td>
                <td>Yes</td>
              </tr>
              <tr>
                <td>Location / GPS Data</td>
                <td>Yes</td>
                <td>Yes</td>
              </tr>
              <tr>
                <td>Alerts, Goals, Reports</td>
                <td>Yes</td>
                <td>Yes</td>
              </tr>
              <tr>
                <td>Number of Caregivers Access</td>
                <td>2</td>
                <td>4</td>
              </tr>
              <tr>
                <td>Price / month</td>
                <td style={{fontWeight: "bold"}}>{`${currencySymbol}${monthlyStandardAmount}`}</td>
                <td style={{fontWeight: "bold"}}>{`${currencySymbol}${monthlyPremiumAmount}`}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    );
  }

  unsubscribe (subscription_id) {
    this.setState({showSpinner: true});

    let userId = '';
    let deviceType = '';

    if (
      this.props.userAccessTokenInfo &&
      this.props.userAccessTokenInfo.userId &&
      this.props.userAccessTokenInfo.userData.device_type
    ) {
      userId = this.props.userAccessTokenInfo.userId;
      deviceType = this.props.userAccessTokenInfo.userData.device_type;
    }

    this.PlansAction.unsubscribe(subscription_id, (actionCallback) => {
      if (actionCallback.status === OperationStatus.SUCCESS) {
        let encryptedSecretKey = CryptoJS.AES.encrypt(process.env.REACT_APP_SUBSCRIPTION_KEY,process.env.REACT_APP_SUBSCRIPTION_KEY).toString();
        let finalEncryptedSecretKey = encryptedSecretKey.split('/').join('atman123').split('+').join('allwell123');

        this.setState({ 
          unsubscribeSuccessful: true, 
          unsubscribeResponseData: actionCallback.data.data,
          showSpinner: false, 
        });
        this.props.history.push(`/upgrade/${userId}/${deviceType}/${finalEncryptedSecretKey}`);
        }
      else {
        this.setState({ 
          errorCase: true, 
          errorMessage: actionCallback.error.errorMessage,
          showSpinner: false, 
        });
      }
    })
  }

  handleShowAccessModal() {
    this.setState({showAccessModal: true});
  }

  handleCloseAccessModal() {
    this.setState({showAccessModal: false});
  }

  renderTransactionHistoryUI() {
    let transactionHistoryLabel = `Transaction History`;
    let paidByName = "-";
    let transactionId = "-";
    let subscriptionId = "";
    let planName = "-";
    let startDateText = "-";
    let termLength = Strings("Annual"); 
    let autoRenewalText = "-";
    let paymentMode = "-";
    let caregivers = 0;
    let totalCaregiversAllowed = 0;
    let upgradeType = "-";
    let paidByFirstName = "-";
    let paidByLastName = "-";

    if (this.props.subscriptionTransactionHistory && this.props.subscriptionTransactionHistory.transactions.length !== 0) {
      this.props.subscriptionTransactionHistory.transactions.map((transaction,index) => {
         if (transaction && transaction.subscription_object && transaction.subscription_object.subscription_status === "SUCCESS") {
           
          if (transaction.subscription_object.subscription_type === 'STRIPE') {

            if (transaction.auto_renew) {
              autoRenewalText = Strings("On");
            }
            else {
              autoRenewalText = Strings("Off");
            }

            if (transaction.subscription_object.stripe_subscription) {
              if (transaction.subscription_object.stripe_subscription.plan) {
                if (
                  transaction.subscription_object.stripe_subscription.plan.nickname.includes(
                    "Yearly"
                  )
                ) {
                  planName =
                    transaction.subscription_object.stripe_subscription.plan.nickname.split(
                      "Yearly"
                    )[0];
                } else if (
                  transaction.subscription_object.stripe_subscription.plan.nickname.includes(
                    "Monthly"
                  )
                ) {
                  planName =
                    transaction.subscription_object.stripe_subscription.plan.nickname.split(
                      "Monthly"
                    )[0];
                } else {
                  planName =
                    transaction.subscription_object.stripe_subscription.plan
                      .nickname;
                }
              
                //todo: refine this below logic of displaying total caregivers allowed according to subscribed plan
                if (transaction.subscription_object.stripe_subscription.plan.nickname.includes('Standard')) {
                  totalCaregiversAllowed = 2
                }
                else {
                  totalCaregiversAllowed = 4
                }

                  // planName = transaction.subscription_object.stripe_subscription.plan.nickname

                  var interval = undefined
                  if (transaction.subscription_object.stripe_subscription.plan.interval) {
                      interval = transaction.subscription_object.stripe_subscription.plan.interval
                  }

                  if (interval) {
                      if (interval === SUBSCRIPTION_INTERVAL.MONTHLY) {
                          termLength = Strings("Monthly")
                      } else if (interval === SUBSCRIPTION_INTERVAL.ANNUAL) {
                          termLength = Strings("Annual")
                      }
                  }
              }

              let startDate = transaction.subscription_object.payment_made_on
              if (startDate) {
                startDateText = moment(startDate).format("MMM DD, YYYY")
              }



              if (transaction.subscription_object.stripe_subscription.customer
                  && transaction.subscription_object.stripe_subscription.customer.invoice_settings
                  && transaction.subscription_object.stripe_subscription.customer.invoice_settings.default_payment_method
                  && transaction.subscription_object.stripe_subscription.customer.invoice_settings.default_payment_method.card) {
                  let cardInfo = transaction.subscription_object.stripe_subscription.customer.invoice_settings.default_payment_method.card
                  let cardLastFour = cardInfo.last4
                  let cardBrand = cardInfo.brand

                  if (cardBrand) {
                      paymentMode = cardBrand
                  }

                  if (cardLastFour) {
                      paymentMode = paymentMode + " x" + cardLastFour
                  }
              }
          }
          }
          
          if (transaction.upgrades_list) {
            if (transaction.upgrades_list.length > 0) {
              transaction.upgrades_list.map(upgradeItem => {
                  caregivers = caregivers + upgradeItem.connection_count
                  return caregivers;
              })
            }

            let firstUpgradeItem = transaction.upgrades_list[0];

            if (firstUpgradeItem) {
              if (firstUpgradeItem.upgraded_connections && firstUpgradeItem.upgraded_connections.length > 0) {
                var upgradedConnection = firstUpgradeItem.upgraded_connections[0]
                if (upgradedConnection && upgradedConnection.product && upgradedConnection.product.display_name) {
                    upgradeType = upgradedConnection.product.display_name;
                }
              }
            }

          }
          paidByFirstName = transaction.paid_by.first_name ? transaction.paid_by.first_name : '-';
          paidByLastName = transaction.paid_by.last_name ? transaction.paid_by.last_name : '-';
          paidByName = `${paidByFirstName} ${paidByLastName}`;
          transactionId = `${transaction.transaction_id}`;
          subscriptionId = `${transaction.subscription_object.subscription_id}`;
         }
      });
    }
    
    
    return (
      <>
      <div className="planSummaryContainer">
        <h6 className="purchaseSummaryHeader">My Plan Status</h6>
        <div className="purchaseSummaryInnerContainer">
          <div className="purchaseSummaryTitleContainer">
            <h6 className="purchaseSummaryTitleText">{Strings("Name")}</h6>
            <h6 className="purchaseSummaryValue">
              {planName}
            </h6>
          </div>
          <div className='purchaseSummaryDivider'></div>

          <div className="purchaseSummaryTitleContainer">
            <h6 className="purchaseSummaryTitleText">{Strings("StartDate")}</h6>
            <h6 className="purchaseSummaryValue">
              {startDateText}
            </h6>
          </div>
          <div className='purchaseSummaryDivider'></div>

          <div className="purchaseSummaryTitleContainer">
            <h6 className="purchaseSummaryTitleText">{"Connection Count"}</h6>
            <h6 className="purchaseSummaryValue">
              {caregivers + '/' + totalCaregiversAllowed}
            </h6>
          </div>
          <div className='purchaseSummaryDivider'></div>

          <div className="purchaseSummaryTitleContainer">
            <h6 className="purchaseSummaryTitleText">{"Term"}</h6>
            <h6 className="purchaseSummaryValue">
              {termLength}
            </h6>
          </div>
          <div className='purchaseSummaryDivider'></div>

          <div className="purchaseSummaryTitleContainer">
            <h6 className="purchaseSummaryTitleText">{"Auto Renewal"}</h6>
            <h6 className="purchaseSummaryValue">
              {autoRenewalText}
            </h6>
          </div>
          <div className='purchaseSummaryDivider'></div>

          <div className="purchaseSummaryTitleContainer">
            <h6 className="purchaseSummaryTitleText">{"Paid By"}</h6>
            <h6 className="purchaseSummaryValue">
            {paymentMode}
            </h6>
          </div>
        </div>
      </div>
      <div className="transactionHistoryContainer">
        <h6 className="transactionHistoryHeader">{transactionHistoryLabel}</h6>
        <div className="transactionHistoryTableContainer">
          <table>
            <thead>
              <tr>
              <th>Paid By</th>
              <th>Upgrade</th>
              <th>Transaction ID</th>
              </tr>
            </thead>
            <tbody>
              <tr>
              <td>{paidByName}</td>
              <td>
                { 
                  <div className="accessPeopleListContainer">
                  <div className="upgradeTypeLabel">{upgradeType}</div>
                  <div className="accessBtnContainer">
                  <Button
                    className="accessBtn" disabled={false} onClick={this.handleShowAccessModal}>
                    {caregivers + " access"}
                  </Button> 
                  
                  </div>
                  </div>                  
                }
              </td>
              <td>{transactionId}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="unsubscribeBtnContainer">
          <div className="btnWrapper">
            <Button
              className="unsubscribeBtn" disabled={false} 
              onClick={ ()=>
                {
                  this.unsubscribe(subscriptionId);
                }
              }>
              {"Unsubscribe"}
            </Button>
          </div>
        </div>
      </div>
      </>
    );
  }

  PlanInfoImage = (country_code) => {
    if (country_code === "IND") {
      return (
        <>
          <img src={PlansInfoIND} alt={"Plans Info for India"} />
        </>
      );
    } else {
      return (
        <>
          <img src={PlansInfoUSA} alt={"Plans Info other than India"} />
        </>
      );
    }
  };

  getProductIdOfSelectedPlan(selectedPlanName) {
    let productId;
    this.props.productsPlanInfo.products.map((item) => {
      if (item.display_name === selectedPlanName) {
        productId = item.id;
      }
      return null;
    });
    return productId;
  }

  proceedToCheckoutPage = (country_code, device_type) => {
    let selectedPlanToUpgrade = this.state.selectedPlan;
    let productId = this.getProductIdOfSelectedPlan(selectedPlanToUpgrade);
    let deviceType = device_type; // Android: 1, iOS: 2, Web: 3
    // let freePlanLovedOnes = [];
    let freePlanCareGivers = [];
    // let basicPlanLovedOnes = [];
    // let basicPlanCaregivers = [];
    // let premiumPlanLovedOnes = [];
    let premiumPlanCaregivers = [];
    // let standardPlanLovedOnes = [];
    let standardPlanCaregivers = [];
    // let advancedPlanLovedOnes = [];
    // let advancedPlanCaregivers = [];
    let paidForUserId = this.props.userAccessTokenInfo && this.props.userAccessTokenInfo.userId;
    // let paidForUserMappingId = "";
    let caregiverUpgradeConnectionArray = []
    let countryCode = country_code;

    let selfUpgrade = {status: true, product_id: productId};

    this.props.userMappingsList.monitoringUsers.forEach((user) => {
      if (user.subscription.product.display_name === SUBSCRIPTION_PLAN_NAME.FREE) {
        freePlanCareGivers.push(user);
      } 
      // else if (user.subscription.product.display_name === SUBSCRIPTION_PLAN_NAME.BASIC) {
      //   basicPlanCaregivers.push(user);
      // } 
      if (user.subscription.product.display_name === SUBSCRIPTION_PLAN_NAME.PREMIUM) {
        premiumPlanCaregivers.push(user);
      }
      
      if (user.subscription.product.display_name === SUBSCRIPTION_PLAN_NAME.STANDARD) {
        standardPlanCaregivers.push(user);
      }
      // else if (user.subscription.product.display_name === SUBSCRIPTION_PLAN_NAME.ADVANCED) {
      //   advancedPlanCaregivers.push(user)
      // }
    });

    // If Free Plan Loved Ones Of the loggedIn User Exist we are upgrading plan for all present caregivers in the array!
    // Todo: Optimization of this logic in case of caregiver selection.
    if (freePlanCareGivers && freePlanCareGivers.length !==0) {

      freePlanCareGivers.forEach((caregiver) => {
        if (caregiver) {
          let caregiver_user_id = caregiver.id;
          let mapping_id = caregiver.subscription && caregiver.subscription.client_user_mapping;
          caregiverUpgradeConnectionArray.push({user_id:caregiver_user_id, mapping_id:mapping_id, product_id: productId});
        }
     });

      // console.log('Connection Upgrades Array :',caregiverUpgradeConnectionArray);

      this.createTransaction(deviceType, paidForUserId, selfUpgrade, caregiverUpgradeConnectionArray, countryCode);
    }
    else {
      this.setState({errorCase:true, errorMessage: "Please invite and connect with your caregivers to upgrade!", showSpinner: false});
    }
  };

  handlePlanSelection = (event) => {
    this.setState({ selectedPlan: event.target.value });
  };

  handleCancelBtnClick = (props) => {
    let deviceType = props.userAccessTokenInfo && props.userAccessTokenInfo.userData && props.userAccessTokenInfo.userData.device_type;
    CommonUtils.handleRedirection("fail", deviceType);

    setTimeout(() => {
      window.location.replace("about:blank");
    },1500);
  }

  renderErrorUI = () => {
    return (
      <>
        <div className="errorContainer">
          {this.renderAlert()}
        </div>
      </>
    );
  };

  renderMainUI = (fullName, mobile, countryCode, deviceType, email) => {
    return (
      <>
      <div className="Plans">
          <Card className="AccountContainer">
            <div className="heading">
              <CardContent>{"User Details"}</CardContent>
            </div>
            <div className="innerSettingDataVertical">
              <div className="innerHeading">
                <CardContent className="innerHeadingData1">
                  {"Name"}
                </CardContent>
                <CardContent className="innerHeadingData2">
                  {fullName}
                </CardContent>
              </div>
              { mobile && 
              <div className="innerHeading">
                <CardContent className="innerHeadingData1">
                  {"Mobile"}
                </CardContent>
                <CardContent className="innerHeadingData2">
                  {mobile}
                </CardContent>
              </div>
              }
              { email && 
              <div className="innerHeading">
                <CardContent className="innerHeadingData1">
                  {"Email"}
                </CardContent>
                <CardContent className="innerHeadingData2">
                  {email}
                </CardContent>
              </div>
              }
            </div>
          </Card>
          {/* PLAN INFO IMAGE OR SECTION */}
          {
          this.state.freePlanCaregiversExists && !this.state.activeTransactionExists ? 
          (
          <>
          <div className="planSectionContainer">
            <div className="planInfoTableContainer">
                {/* {this.PlanInfoImage(countryCode)} */}
                {this.renderPlanComparisonTable(countryCode)}
            </div>
            {/* PLAN SELECTION FORM */}
              <div className="selectPlanFormSection">
                <form>
                  <div className="selectPlanLabel">
                    Select a subscription plan
                  </div>
                  <div className="plansOptionsContainer">
                    <div className="plansOptions">
                      <RadioGroup
                        row
                        className="radioBtnGroup"
                        defaultValue="Standard"
                        name="subscription-plan-group"
                      >
                        {/* <FormControlLabel
                          value="BASIC"
                          disabled={false}
                          className="radioBtnLabel"
                          control={
                            <Radio onChange={this.handlePlanSelection} />
                          }
                          label="Basic"
                          checked={this.state.selectedPlan === "BASIC" && true}
                        /> */}
                        <FormControlLabel
                          value="STANDARD"
                          disabled={false}
                          className="radioBtnLabel"
                          control={<Radio onChange={this.handlePlanSelection} />}
                          label="Standard"
                          checked={this.state.selectedPlan === "STANDARD" && true}
                        />
                        <FormControlLabel
                        value="PREMIUM"
                        disabled={false}
                        className="radioBtnLabel"
                        control={<Radio onChange={this.handlePlanSelection} />}
                        label="Premium"
                      />
                      {/* <FormControlLabel
                        value="ADVANCED"
                        disabled={true}
                        className="radioBtnLabel"
                        control={<Radio onChange={this.handlePlanSelection}/>}
                        label="Advanced"
                      /> */}
                      </RadioGroup>
                    </div>
                  </div>
                </form>
                <div className="btnWrapper">
                  <Button
                    className="proceedBtn"
                    onClick={() => {
                      this.proceedToCheckoutPage(countryCode, deviceType);
                    }}
                  >
                    {"Upgrade"}
                  </Button>
                </div>
                <div className="cancelBtn" onClick={()=>{this.handleCancelBtnClick(this.props)}}>CANCEL</div>
              </div>
            </div>
          </>
          ) : 
          (
          <>
            {this.state.activeTransactionExists && this.renderTransactionHistoryUI()}
          </>
          )
          }
          
        </div>
      </>
    )
  }

  render() {
    const { userAccessTokenInfo } = this.props;
    const firstName = (userAccessTokenInfo && userAccessTokenInfo.userData && userAccessTokenInfo.userData.first_name) ? userAccessTokenInfo.userData.first_name : "-";
    const lastName =  (userAccessTokenInfo && userAccessTokenInfo.userData && userAccessTokenInfo.userData.last_name) ? userAccessTokenInfo.userData.last_name : "";
    const fullName = `${firstName} ${lastName}`;
    const mobile = (userAccessTokenInfo && userAccessTokenInfo.userData) ? userAccessTokenInfo.userData.mobile : "";
    const countryCode = (userAccessTokenInfo && userAccessTokenInfo.userData) ? userAccessTokenInfo.userData.country_code : "";
    const deviceType = (userAccessTokenInfo && userAccessTokenInfo.userData) ? userAccessTokenInfo.userData.device_type : "";
    const email = (userAccessTokenInfo && userAccessTokenInfo.userData) ? userAccessTokenInfo.userData.email : "";

    return (
      <div>
        {this.state.errorCase ? this.renderErrorUI() : this.renderMainUI(fullName, mobile, countryCode, deviceType, email)}
        <Spinner showModal={this.state.showSpinner} />{" "}
        <AccessModal 
        show={this.state.showAccessModal} 
        handleClose={this.handleCloseAccessModal}
        children={this.state.activeTransaction && this.state.activeTransaction.upgrades_list} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userAccessTokenInfo: state.UpgradeHandler.userAccessTokenInfo,
    deviceType: state.UpgradeHandler.userAccessTokenInfo.userData.deviceType,
    subscriptionTransactionHistory: state.Plans.subscriptionTransactionHistory,
    userMappingsList: state.Plans.userMappingsList,
    productsPlanInfo: state.Plans.productsPlanInfo,
    createTransactionResponse: state.Plans.createTransactionResponse,
  };
}
function matchDispatchToProps(dispatch) {
  return {
    cleanCreateTransactionData: () => dispatch({type: "CLEAN_CREATE_TRANSACTION_DATA"}),
  };
}

export default withRouter(
  connect(mapStateToProps, matchDispatchToProps)(Plans)
);
